import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLanguage();
  const sections = t("privacy.sections") || [];

  return (
    <main className="min-h-screen bg-[#0a0a0a] text-[#cbc1ad] py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#d89557] hover:text-[#f4ede0] transition mb-10"
        >
          <ArrowLeft className="w-4 h-4" />
          {t("legal.backHome")}
        </Link>

        <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">
          {t("privacy.label")}
        </span>
        <h1 className="font-display text-4xl sm:text-5xl text-[#f4ede0] mt-3 mb-4 leading-[1.1]">
          {t("privacy.title")}
        </h1>
        <p className="text-xs text-[#7a716a] uppercase tracking-[0.22em] mb-10">
          {t("privacy.lastUpdate")}
        </p>

        <div className="space-y-8">
          {Array.isArray(sections) &&
            sections.map((s) => (
              <section key={s.h}>
                <h2 className="font-display text-lg sm:text-xl text-[#f4ede0] mb-3">
                  {s.h}
                </h2>
                <div className="text-sm leading-relaxed whitespace-pre-line">{s.p}</div>
              </section>
            ))}
        </div>
      </div>
    </main>
  );
}
